/**
 * Common Switch Props
 */
export var switchProps = {
  value: null,
  loading: Boolean,
  disabled: Boolean,
  activeColor: String,
  inactiveColor: String,
  activeValue: {
    type: null,
    default: true
  },
  inactiveValue: {
    type: null,
    default: false
  },
  size: {
    type: String,
    default: '30px'
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/switch/shared.js
// module id = 68
// module chunks = 0 6